<template>
  <a-modal
    title="Dodaj rezerwację"
    width="40vw"
    wrapClassName="modal-wrapper"
    v-model="visible"
    @ok="onSubmit"
    @cancel="closeModal"
    :confirm-loading="loading"
    :ok-button-props="{ props: { disabled: isFormDisabled } }"
    okText="Zarezerwuj"
    cancelText="Anuluj"
  >
    <inner-form
      v-model="form"
      :errors="errors"
      @submit="onSubmit"
      :courses="courses"
      :is-form-disabled="isFormDisabled"
    />
  </a-modal>
</template>
<script>
import InnerForm from './InnerForm'
import { Reservation, Course } from '@/api'
import { uniq } from 'lodash'
import moment from 'moment'

export default {
  data() {
    return {
      visible: false,
      form: {
        duration: 60
      },
      errors: {},
      courses: [],
      loading: false
    }
  },
  components: {
    InnerForm
  },
  computed: {
    isFormDisabled() {
      const selectedCourse = this.courses.find(
        course => course.id === this.form.course
      )
      return selectedCourse?.is_group && this.isStudent
    }
  },
  methods: {
    openModal({ date, lecturerId, studentId, courseId }) {
      this.visible = true
      this.lecturerId = lecturerId
      this.studentId = studentId
      this.form = {
        selectedDate: moment(date),
        selectedLecturer: lecturerId,
        selectedStudent: studentId,
        course: courseId,
        duration: 60
      }
      this.fetchCourses()
    },
    fetchCourses() {
      const params = {
        lecturer: this.lecturerId,
        students: this.studentId,
        is_completed: false
      }
      Course.all(params).then(res => {
        this.courses = res.data.results.map(course => ({
          ...course,
          label: course.name,
          value: course.id
        }))
        if (!this.courses.find(course => course.id === this.form.course)) {
          this.$set(this.form, 'course', null)
        }
        if (this.courses.length === 1) {
          this.form.course = this.courses[0].value
        }
      })
    },
    onSubmit() {
      this.loading = true
      Reservation.save(this.form)
        .then(() => {
          this.$notification.success({ message: 'Prośba o rezerwację wysłana' })
          this.closeModal()
          this.$emit('submit')
        })
        .catch(err => {
          const data = err.response.data
          this.$message.error('W formularzu znajduje się błąd')
          this.errors = err.response.data

          const reservedSlots = data.reserved_slots || []
          const nonFieldSlotErrors = uniq(
            reservedSlots
              .map(slot => slot.non_field_errors)
              .filter(error => error)
          )

          if (this.errors.non_field_errors) {
            this.errors.non_field_errors.push(...nonFieldSlotErrors)
          } else {
            this.errors.non_field_errors = nonFieldSlotErrors
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeModal() {
      this.visible = false
      this.form = { duration: 60 }
      this.courses = []
      this.errors = {}
    }
  }
}
</script>
